import { Pressable, View } from 'react-native';
import { cn } from '../../lib/utils';
import { Typography } from '../Typography/Typography';

export type RadioToggleOption = {
  label: string;
  value: string;
};

type RadioToggleProps = {
  options: [RadioToggleOption, RadioToggleOption]; // Exactly two options
  value: string;
  onChange: (value: string) => void;
  className?: string;
  textClassName?: string;
  toggleClassName?: string;
};

export const RadioToggle = ({
  options,
  value,
  onChange,
  className,
  textClassName,
  toggleClassName
}: RadioToggleProps) => {
  return (
    <View
      className={cn(
        'flex flex-row gap-1 items-center bg-neutral-600 rounded-full p-2 h-[40px] w-fit',
        className,
      )}>
      {options.map((option, index) => (
        <Pressable key={index} onPress={() => onChange(option.value)}>
          <View className="h-10 w-10 flex items-center justify-center">
             <View className={cn(
                value === option.value
                  ? 'border border-primary rounded-full h-8 w-8 flex flex-row items-center justify-center text-center py-1.5'
                  : 'border-0',
                  toggleClassName
              )}
            >
            <Typography
              size="medium"
              weight="medium"
              className={cn(
                value === option.value
                  ? 'text-primary'
                  : 'text-neutral-400',
                  textClassName
              )}>
                
                  {option.label}
                
            </Typography>
            </View>
          </View>
        </Pressable>
      ))}
    </View>
  );
};
